const decodeToken = str => {
  // token处理
  return str.replace(/ /g, "+");
};

/**
 * 空字段保护
 * @param {any} field 需要检测的字段
 * @param {any} pField 待替换字段
 * */
const fieldProtaction = (field, pField) => {
  if (!field) {
    if (pField || pField == 0) {
      return pField;
    }
  }
  return field;
};

/**
 *
 * @param {string} str 号正则
 * @param {int} type 类型 1:邮箱 2:手机号
 */
const checkReg = (str, type) => {
  if (type == 1 && str.indexOf("@") == -1) {
    return false;
  }
  if (type == 2 && str.length != 11) {
    return false;
  }
  return true;
};

const getObjByKeyValue = (arr, key, value) => {};

const lookApp = () => {
  var ua = navigator.userAgent;
  var isAndroid = /(Android);?[\s/]+([\d.]+)?/.test(ua);
  var isIpad = /(iPad).*OS\s([\d_]+)/.test(ua);
  var isIpod = /(iPod)(.*OS\s([\d_]+))?/.test(ua);
  var isIphone = !isIpad && /(iPhone\sOS)\s([\d_]+)/.test(ua);
  var isWechat = /micromessenger/i.test(ua);
  var isAlipay = /alipayclient/i.test(ua);
  if (isWechat) {
    alert("请点击右上角，选择在浏览器中打开，下载App后进行观看");
  } else {
    if (isIphone) {
      var iosParams = toiOSDownload();
      window.location.href = iosParams.Schemes;
      setTimeout(function () {
        window.location = iosParams.URL;
      }, 500);
    } else if (isAndroid) {
      var androidParams = toAndroidDownload();
      window.location.href = androidParams.Schemes;
      setTimeout(function () {
        window.location = androidParams.URL;
      }, 500);
    }
  }
};

const toiOSDownload = () => {
  let theme = getUrlKey('theme');
  let appName = getUrlKey('appName');
  if (theme == 'izt' || appName == 'iexhibitionpublic') {
    // i展通公版iOS下载地址
    return { URL:'http://1z1.hk/yURzyu', Schemes: 'iexhibitionpublic://iexhibitionpublic'};
  }else if (theme == 'baoli') {
    // 保利iOS下载地址
    return { URL:'https://apps.apple.com/cn/app/id1512538976', Schemes: 'iexhibitionbaoli://iexhibitionbaoli'};
  }else if(theme=='jingdong'){
    // 京东下载地址
    return { URL:'https://apps.apple.com/cn/app/id1517584168', Schemes: 'iexhibitionjingdong://iexhibitionjingdong'};
  }else if(theme=='jinrong' || theme== 'jinrongzhan'){
    // 金融下载地址
    return { URL:'https://apps.apple.com/cn/app/id1530757518', Schemes: 'iexhibitionjinrong://iexhibitionjinrong'};
  }
  // 默认保利
  return { URL:'https://apps.apple.com/cn/app/id1512538976', Schemes: 'iexhibitionbaoli://iexhibitionbaoli'};
}

const toAndroidDownload = () => {
  let theme = getUrlKey('theme');
  let appName = getUrlKey('appName');
  if (theme == 'izt' || appName == 'iexhibitionpublic') {
    // i展通公版Android下载地址
    return { URL:'http://1z1.hk/yURzyu', Schemes: 'iexhibitionpublic://iexhibitionpublic'};
  }else if (theme == 'baoli') {
    // 保利Android下载地址
    return { URL:'http://izt.eastfair.cn/package/imaster_baoli.apk', Schemes: 'iexhibitionbaoli://iexhibitionbaoli'};
  }else if(theme=='jingdong'){
    // 京东app下载地址
    return { URL:'http://izt.eastfair.cn/package/imaster_jingdong.apk', Schemes: 'iexhibitionjingdong://iexhibitionjingdong'};
  }else if(theme=='jinrong' || theme== 'jinrongzhan'){
    // 金融下载地址
    return { URL:'http://izt.eastfair.cn/package/imaster_jinrong_3.1.1.apk', Schemes: 'iexhibitionjinrong://iexhibitionjinrong'};
  }
  return { URL:'http://izt.eastfair.cn/package/imaster_baoli.apk', Schemes: 'iexhibitionbaoli://iexhibitionbaoli'};
}

const getUrlKey = (name) => {
  let value = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
  if (value) {
   return value.replace(/\//g, '') 
  }
  return null;
}

const uuid = () => {
	var s = [];
	var hexDigits = "0123456789abcdef";
	for (var i = 0; i < 36; i++) {
		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
	}
	s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
	s[8] = s[13] = s[18] = s[23] = "-";

	var uuid = s.join("");
	return uuid;
}

export default {
  decodeToken,
  fieldProtaction,
  lookApp,
  checkReg,
  uuid
};